import type { TRPCLink } from "@trpc/client";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import { observable } from "@trpc/server/observable";
import superjson from "superjson";
import type { AppRouter } from "../../data-service/src/trpcRouters/root";

type Listener = () => void;
const unauthorizedListeners = new Set<Listener>();

/** Notified whenever the server says the session is missing or expired. */
export const onUnauthorized = (listener: Listener): (() => void) => {
  unauthorizedListeners.add(listener);
  return () => {
    unauthorizedListeners.delete(listener);
  };
};

const sessionExpiryLink: TRPCLink<AppRouter> =
  () =>
  ({ next, op }) =>
    observable((observer) =>
      next(op).subscribe({
        next: (value) => observer.next(value),
        complete: () => observer.complete(),
        error: (error) => {
          if (error.data?.code === "UNAUTHORIZED" && op.path !== "auth.login") {
            unauthorizedListeners.forEach((listener) => listener());
          }
          observer.error(error);
        },
      })
    );

export const trpc = createTRPCClient<AppRouter>({
  links: [
    sessionExpiryLink,
    httpBatchLink({ url: "/api/trpc", transformer: superjson }),
  ],
});
